import React from 'react'
import { FarmerDashboardLayout } from '../layouts';
import AssistantPage from '../../application/assets/images/farmerspages/assistantpage.png'


function FarmerAssistant() {


    return (
        <FarmerDashboardLayout>


            <div className='  '>

                <img src={AssistantPage} alt="" />

            </div>


        </FarmerDashboardLayout>
    )
}

export default FarmerAssistant